import React from "react";
import { Redirect, Route } from "react-router-dom";
import lstool from "./localStorage";
function PrivetRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        lstool.check() ? <Component {...props} /> : <Redirect to={"/login"} />
      }
    />
  );
}
function RegisterComponent({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        !lstool.check() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}
export { PrivetRoute, RegisterComponent };
